import * as React from 'react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';

export interface DateInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type'
> {
  /** Calendar date as YYYY-MM-DD (what the API expects); null/undefined = empty. */
  value: string | null | undefined;
  onChange: (iso: string | null) => void;
}

/**
 * Native `<input type="date">` wrapper. The browser renders the date in the user's locale
 * (DD.MM.YYYY for de/ro), while the value stays YYYY-MM-DD. Clearing yields `null`.
 */
export const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ value, onChange, className, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="date"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value ? e.target.value : null)}
        className={cn('w-auto min-w-[10rem] tabular-nums', className)}
        {...props}
      />
    );
  },
);
DateInput.displayName = 'DateInput';
